"use client"

import { useEffect } from "react"
import { usePathname, useRouter } from "next/navigation"

import { pagesPath } from "@/config/$path"
import { useCurrentUser } from "@/app/_hooks/useCurrentUser"
import { useCurrentWorkingCompany } from "@/app/_hooks/useCurrentWorkingCompany"

export default function RedirectProvider() {
  const router = useRouter()
  const { userId, email, stateReady: authStateReady } = useCurrentUser() ?? {}
  const { company, stateReady: companyStateReady } = useCurrentWorkingCompany()

  const { companyId } = company ?? {}
  const expiredAtHash = company?.expiredAt?.toDateString()

  const pathname = usePathname()

  const stateReady = authStateReady && companyStateReady

  // !WARNING: 一歩間違えると、無限ループのリスクがある
  useEffect(() => {
    if (!stateReady) {
      return
    }

    const authPath = pagesPath.auth.$url().path
    // /auth ページにいる場合の処理
    if (pathname.startsWith(authPath)) {
      // 認証済みの場合のリダイレクト処理
      if (userId != null && email != null) {
        // 企業未登録の場合は /join へリダイレクト
        if (companyId == null) {
          const joinPath = pagesPath.join.$url().path
          router.replace(joinPath)

          return
        }

        // 企業登録済みの場合は企業ページへリダイレクト
        router.replace(pagesPath._companyId(companyId).$url().path)

        return
      }

      // 未認証の場合や、OTP入力中の場合は、OtpPageForm がリダイレクトを担当するため、
      // RedirectProvider はリダイレクトしない
      // 背景: 他の箇所とは異なりheaderに認証情報をセットしないといけないため
      // 再度リクエストを送らざるを得ない。そのため共通化は諦める。
      return
    }

    // 未認証ユーザーを /auth へリダイレクト
    if (userId == null || email == null) {
      router.replace(authPath)

      return
    }

    if (companyId == null) {
      const joinPath = pagesPath.join.$url().path
      if (pathname.startsWith("/K-")) {
        router.replace(joinPath)
      }

      if (!pathname.startsWith(joinPath)) {
        router.replace(joinPath)
      }

      return
    }

    // 企業登録導線は companyId を持つユーザーでも開けるようにする
    const joinPath = pagesPath.join.$url().path
    if (pathname.startsWith(joinPath)) {
      return
    }

    if (expiredAtHash && !(pathname === "/suspended")) {
      router.replace(pagesPath.suspended.$url().path)

      return
    }

    // 企業ページへのリダイレクト (companyIdを含まないパス、かつsuspendedでない場合)
    if (!pathname.includes(companyId) && !(pathname === "/suspended")) {
      router.replace(pagesPath._companyId(companyId).$url().path)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, email, stateReady, companyId, expiredAtHash, pathname, router])

  return <div></div>
}
